import { applyMiddleware, combineReducers, legacy_createStore } from "redux";
import userReducer from "./users/user_reducer";
import thunk from "redux-thunk";
import { noteReducer } from "./notes/note_reducer";
import { destinoReducer } from "./destinos/destino_reducer";
import { estadoReducer } from "./estados/estado_reducer";

let rootReducer = combineReducers({
    userReducer: userReducer,
    noteReducer: noteReducer,
    destinoReducer: destinoReducer,
    estadoReducer: estadoReducer
})

export const store = legacy_createStore(rootReducer, applyMiddleware(thunk))